import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36d9fb5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto" }

import { useUserStore } from '@/store/user';
import ReceiveSearch from '@/components/Receive/ReceiveSearch.vue';
import ReceiveNFTTable from '@/components/Receive/ReceiveNFTTable.vue';
import type { ClaimingReceiveResponse } from '@/types/Claiming';
import { onMounted, computed, ref, watch } from 'vue';
import useMoralis from '@/composables/useMoralis';
import Moralis from 'moralis';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const moralis = useMoralis();
const userStore = useUserStore();
const authenticated = computed(() => !!userStore.me);
let paymentTransactions = ref<ClaimingReceiveResponse>();
const currentPage = ref<number>(1);

watch(currentPage, () => {
  getPaymentTransactions();
});
const getPaymentTransactions = async () => {
  try {
    const data: ClaimingReceiveResponse = await moralis.currect.Cloud.run(
      'getPaymentTransactions',
      {
        page: currentPage.value,
        token: userStore.sessionToken,
        sort: 'createdAt',
        reverse: 'true',
        size: 10,
      }
    );
    paymentTransactions.value = data;
  } catch (err) {
    moralis.handleMoralisError(err as Moralis.Error);
    paymentTransactions.value = undefined;
  }
};
onMounted(() => {
  if (authenticated.value) {
    getPaymentTransactions();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BasePagination = _resolveComponent("BasePagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(authenticated))
      ? (_openBlock(), _createBlock(ReceiveSearch, {
          key: 0,
          class: "mt-8",
          onUpdate: _cache[0] || (_cache[0] = ($event: any) => (_isRef(paymentTransactions) //@ts-ignore
 ? paymentTransactions.value = $event : paymentTransactions = $event))
        }))
      : _createCommentVNode("", true),
    _createVNode(ReceiveNFTTable, { transactions: _unref(paymentTransactions) }, null, 8, ["transactions"]),
    (
        _unref(paymentTransactions) &&
        _unref(paymentTransactions).entities.length &&
        _unref(paymentTransactions).pageInfo.totalPage > 1
      )
      ? (_openBlock(), _createBlock(_component_BasePagination, {
          key: 1,
          onPageCurrent: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value = $event)),
          list: _unref(paymentTransactions).pageInfo.count,
          "data-per-page": _unref(paymentTransactions).pageInfo.size
        }, null, 8, ["list", "data-per-page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})